import React from 'react';
import { hoverHelpers } from 'shared-helpers';
import { getInvestorURL, getInvestorLogo } from './helpers/detailRowHelpers';
import { amountFormatter } from '/src/lib/helpers';


export const InvestorDetailModal = ({ investedInName, investorData, investedInId, userHasDirectoryAccess, selectedFundingStageName, isFundingView }) => {

    if (!investorData) {
        return null;
    }

    const handleInvestedAmount = (inv) => {
        if (Boolean(Number(inv?.amount)))
            return amountFormatter(inv.amount);
        if (Boolean(Number(inv?.estimated_invested_amount)))
            return amountFormatter(inv.estimated_invested_amount);
        return "Undisclosed";
    };
    // Sort investorData to put lead investors first
    const investorArr = isFundingView ? [...investorData].sort((a, b) => {
        const aIsLead = Boolean(Number(a?.is_lead));
        const bIsLead = Boolean(Number(b?.is_lead));
        a.isLeadInvestor = a.isLeadInvestor || Boolean(Number(a?.is_lead));
        b.isLeadInvestor = b.isLeadInvestor || Boolean(Number(b?.is_lead));

        a.investedAmount = a.investedAmount || handleInvestedAmount(a);
        b.investedAmount = b.investedAmount || handleInvestedAmount(b);

        // Lead investors first (true comes before false)
        if (aIsLead && !bIsLead) return -1;
        if (!aIsLead && bIsLead) return 1;
        return 0; // Keep original order for same type
    }) : investorData;

    let modalData = [];
    investorArr.map((inv, i) => {
        const { isLeadInvestor, investedAmount } = inv;

        const className  = isFundingView && 'investorLogo';
        const invImage = getInvestorLogo(inv, className);
        const investorUrl = getInvestorURL(inv);

        modalData.push(
            <div className="d-flex align-items-center justify-content-between"
                style={{width: '100%', marginTop: i < 1 ? '0' : '15px'}}
            >
                <a className="d-flex align-items-center"
                    key={inv.id + `-${i}-${investedInId ? investedInId : 'uniqueKey'}`}
                    href={investorUrl && `/${investorUrl}`}
                    target={investorUrl && "_blank"}
                    rel={investorUrl && "noopener noreferrer"}>
                    <div className="d-flex align-items-center justify-content-between">
                        {invImage}
                        <div className="startup-name" style={{margin: '0 9px'}} >
                            <div
                                onMouseEnter={(event) => hoverHelpers.handleEntityHover(inv, event, userHasDirectoryAccess)}
                                onMouseLeave={() => hoverHelpers.handleMouseOut()}
                            >{inv.name}</div>
                            {isLeadInvestor && <span className='lead-investor'>Lead Investor</span>}
                        </div>
                    </div>

                </a>
                {investedAmount && <span>{investedAmount}</span>}
            </div>
        )

    });

    return (
        <div className="modal fade" id={"investors-modal"} tabIndex="-1" role="dialog" aria-labelledby="" aria-hidden="true" data-backdrop="false">
            <div className="filterBackground" data-dismiss="modal"></div>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <div>
                            <h5 className="modal-title " id="exampleModalLabel">Investors - {investedInName}  </h5>
                            {isFundingView && <div className="startup-name">Funding Stage - {selectedFundingStageName}</div>}
                        </div>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {modalData}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default InvestorDetailModal;
